import { Component, ViewChild, AfterViewInit, inject } from '@angular/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { DeviceDetectorService } from '../../services/device-detector.service';
import { Libreria } from '../../model/Libreria';
import { LibreriasService } from '../../services/librerias.service';

@Component({
  selector: 'app-librerias',
  imports: [MatTableModule, MatProgressSpinnerModule, MatSortModule, MatPaginatorModule, CommonModule],
  templateUrl: './librerias.component.html',
  styleUrl: './librerias.component.scss'
})
export class LibreriasComponent implements AfterViewInit {

  librerias: Libreria[] = [];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  @ViewChild(MatPaginator) paginator: MatPaginator = new MatPaginator();
  @ViewChild(MatSort) sort: MatSort = new MatSort();
  private service = inject(LibreriasService);
  private deviceService = inject(DeviceDetectorService);
  constructor() {
  }

  ngOnInit() {
    if (this.deviceService.isMobile()) {
    }
  }

  ngAfterViewInit() {

    // por ahora hay solo una pagina
    this.service.getLiberias(0).subscribe({
      next: (data) => {
        this.librerias = data.items.sort((a,b) => a._id - b._id);
        this.resultsLength = data.total_count;
        this.isLoadingResults = false;
      },
      error: () => {}
    });

  }

}
